import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"
import { HasuraMutations } from "@/api/hasura/mutations"
import { ToggleReferralSettingMutationVariables } from "@/api/hasura/generated/graphql"
import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import { ApplyReferralCodeResponse } from "@/api/backofficeRest/generated/model"
import { IApplyReferralCodePayload } from "./ReferralMutator.types"

export interface IReferralMutator {
  toggleCodeBlacklistStatus(): MutationResult<ToggleReferralSettingMutationVariables>
  applyReferralCode(): MutationResult<
    IApplyReferralCodePayload,
    ApplyReferralCodeResponse
  >
}

export class ReferralMutatorClass implements IReferralMutator {
  toggleCodeBlacklistStatus(): MutationResult<ToggleReferralSettingMutationVariables> {
    return useMutation({
      ...HasuraMutations.referral.toggleCodeBlacklistStatus(),
      serializerFn: (data) => data,
    })
  }

  applyReferralCode(): MutationResult<
    IApplyReferralCodePayload,
    ApplyReferralCodeResponse
  > {
    return useMutation({
      ...BackofficeRestMutations.user.applyReferralCode(),
      serializerFn: (data: IApplyReferralCodePayload) => ({
        customerId: data.customerId,
        body: { referral_code: data.referralCode },
      }),
    })
  }
}

export const ReferralMutator = new ReferralMutatorClass()
